/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ReadInputs */

const cs_enum_read = /** @type {(inputs: Enum_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přečteno`)
};

const en_enum_read = /** @type {(inputs: Enum_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Enum_ReadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_read = /** @type {((inputs?: Enum_ReadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ReadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_read(inputs)
	return cs_enum_read(inputs)
});